import React, { useEffect, useCallback, useContext, useState } from 'react';
// import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import AddressStandardizationComponent from "premier-capability-policyjob-react/components/AddressStandardizationComponent/AddressStandardizationComponent";
import styles from './DriverContactComponent.module.scss';
import metadata from './DriverContactComponent.metadata.json5';
import messages from '../DriverContactComponent/DriverContactComponent.messages';


function DriverContactComponent(props) {
    const {contactVM, onValueChange, setComponentValidation, viewModelService, isDOBMandatory = false} = props;

    if(!contactVM){
        return null;
    }
    const [isPageInitialized, setIsPageInitialized] = useState(false);
    const [selectedPhoneType, updateSelectedPhoneType] = useState({
        homeRadioButton: '',
        workRadioButton: '',
        mobileRadioButton: ''
    });
    const writeValue = (value, path) => {
        const phoneTypes = ['homeRadioButton', 'workRadioButton', 'mobileRadioButton'];

        _.set(contactVM, 'homeRadioButton', '');
        _.set(contactVM, 'workRadioButton', '');
        _.set(contactVM, 'mobileRadioButton', '');

        if (phoneTypes.includes(path)) {
            _.set(contactVM, path, value);
            _.set(contactVM, 'primaryPhoneType.value', value);
            updateSelectedPhoneType({
                homeRadioButton: path === 'homeRadioButton' ? value : '',
                workRadioButton: path === 'workRadioButton' ? value : '',
                mobileRadioButton: path === 'mobileRadioButton' ? value : ''
            });
        }

        const hasPrimaryPhone = _.filter(selectedPhoneType, (p)=> !_.isEmpty(p)).length !== 0

        _.set(contactVM, 'isPhoneNonMandatory', hasPrimaryPhone);
        onValueChange(value, path);
    };
    const translator = useContext(TranslatorContext);

    const onAddressChange = (value, path) => {
        const changedPath = path ? `primaryAddress.${path}` : `primaryAddress`

        writeValue(value, changedPath);        
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        companyContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Company'
        },
        personalContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Person' 
        },
        driverCountry: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.country.aspects.availableValues'
                )
            )
        },
        driverState: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.state.aspects.availableValues'
                )
            )
        },        
        contactAddressComponent:{
            model: contactVM.primaryAddress.value,
            onValidate: setComponentValidation,
            requiredFields: ['addressLine1', 'state', 'postalCode'],
            visible:!!viewModelService,
            viewModelService,
            onValueChange: onAddressChange,
            labelPosition: 'left',
            contactVM
        },
        homeRadioButtonId: {
            visible:
                !_.get(contactVM, 'subtype.value') === 'Company'
                || _.get(contactVM, 'subtype.value') === 'Person',
            value: selectedPhoneType.homeRadioButton ? 'home' : '',
            availableValues: [
                {
                    code: 'home',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        workRadioButtonId: {
            visible:
            !_.get(contactVM, 'subtype.value') === 'Company'
            || _.get(contactVM, 'subtype.value') === 'Person',
            value: selectedPhoneType.workRadioButton ? 'work' : '',
            availableValues: [
                {
                    code: 'work',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        mobileRadioButtonId: {
            visible:
            !_.get(contactVM, 'subtype.value') === 'Company'
            || _.get(contactVM, 'subtype.value') === 'Person',
            value: selectedPhoneType.mobileRadioButton ? 'mobile' : '',
            availableValues: [
                {
                    code: 'mobile',
                    name: translator(messages.primaryNumber)
                }
            ]
        },
        homePhone: {
            required: (selectedPhoneType.homeRadioButton ===  'home'),
            showRequired: (selectedPhoneType.homeRadioButton ===  'home'),
            visible:_.get(contactVM, 'subtype.value') === 'Person'
        },
        workPhone: {
            required: (selectedPhoneType.workRadioButton ===  'work'),
            showRequired: (selectedPhoneType.workRadioButton ===  'work'),
            label:_.get(contactVM, 'subtype.value') === 'Person' ? 'Work Phone' : 'Office Phone'
        },
        faxNumber:{
            visible:_.get(contactVM, 'subtype.value') === 'Company'
        },
        mobilePhone: {
            required: (selectedPhoneType.mobileRadioButton ===  'mobile'),
            showRequired: (selectedPhoneType.mobileRadioButton ===  'mobile'),
            visible:_.get(contactVM, 'subtype.value') === 'Person'
        },

    };

    const initializeRadioButton = useCallback(() => {
        const primaryPhone = _.get(contactVM, 'primaryPhoneType.value.code');
        let selectedPhone = '';

        if (contactVM.value.isPhoneNonMandatory) {
            if (primaryPhone && primaryPhone === 'home') {
                if(contactVM.homeNumber.value ===  'null'){
                    contactVM.primaryPhoneType.value ='null';
                } else {
                    selectedPhone = primaryPhone || 'home';
                }
            } else if (primaryPhone && primaryPhone === 'work') {
                if(contactVM.workNumber.value ===  'null'){
                    contactVM.primaryPhoneType.value ='null';
                } else {
                    selectedPhone = primaryPhone || 'work';
                }
            } else if (primaryPhone && primaryPhone === 'mobile') {
                if(contactVM.cellNumber.value ===  'null'){
                    contactVM.primaryPhoneType.value ='null';
                } else {
                    selectedPhone = primaryPhone || 'mobile';
                }
            }
        } else {
             selectedPhone = primaryPhone;

            if (_.get(contactVM, 'subtype.value') === 'Company') {
                selectedPhone = primaryPhone;
            }

            if (!contactVM.primaryPhoneType.value) {
                onValueChange(selectedPhone, 'primaryPhoneType.value');
            }
        }

        updateSelectedPhoneType({
            workRadioButton: selectedPhone === 'work' ? selectedPhone : '',
            homeRadioButton: selectedPhone === 'home' ? selectedPhone : '',
            mobileRadioButton: selectedPhone === 'mobile' ? selectedPhone : '',
        });

    }, [contactVM, onValueChange]);



    useEffect(() => {
        if(!isPageInitialized){
            initializeRadioButton();
            setIsPageInitialized(true);
        }
    }, [initializeRadioButton, contactVM, isPageInitialized]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            addressStandardizationComponent: AddressStandardizationComponent
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={contactVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default DriverContactComponent;
